import { customersRef, operativesRef, ratesRef } from "./firebase";
import { doc, setDoc } from "firebase/firestore";

import Geocode from "react-geocode";

// console.log("process", import.meta.env.MODE);

let GOOGLE_API_KEY = import.meta.env.VITE_DEV_GOOGLE_MAP_API_KEY;

if (import.meta.env.MODE === "production") {
  GOOGLE_API_KEY = "AIzaSyC6MEgQDJ_nPZU0ZgT4vPOEohF2c44fZL4"; //import.meta.env.PROD_GOOGLE_MAPS_API;
}

// console.log("WHat is key 1", GOOGLE_API_KEY);

// console.log(
//   "GOOGLE APU IN POP DATA",
//   import.meta.env.VITE_DEV_GOOGLE_MAP_API_KEY
// );
// set Google Maps Geocoding API for purposes of quota management. Its optional but recommended.
Geocode.setApiKey(GOOGLE_API_KEY);
Geocode.setLanguage("en");
Geocode.setRegion("gb");
Geocode.setLocationType("ROOFTOP");

// Enable or disable logs. Its optional.
Geocode.enableDebug();
export const geocoder = Geocode;

export const baseUrls = {
  searchEmail: "https://mail.google.com/mail/#search/",
  searchGoogleMaps: "https://www.google.com/maps/place/",
};

export const setPrices = [
  {
    name: "Set Price",
    price: 0.0,
    display: "0.00",
    uid: "0",
  },
  {
    name: "EICR: Flat Rate",
    price: 180.0,
    display: "180.00",
    uid: "1",
  },
  {
    name: "EICR: Additional Circuit",
    price: 20.0,
    display: "20.00",
    uid: "2",
  },
  {
    name: "PAT: Test (x6 items)",
    price: 60.0,
    display: "60.00",
    uid: "3",
  },
  {
    name: "PAT: Additional Item",
    price: 2,
    display: "2.00",
    uid: "4",
  },
  {
    name: "Smoke Detector Survey Check",
    price: 60.0,
    display: "60.00",
    uid: "5",
  },
  {
    name: "Call Out Fee",
    price: 60.0,
    display: "60.00",
    uid: "6",
  },
  {
    name: "Survey Fee Discount",
    price: -60.0,
    display: "-60.00",
    uid: "7",
  },
  {
    name: "Survey Fee Discount",
    price: -80.0,
    display: "-80.00",
    uid: "8",
  },
  {
    name: "Landlord's Electrical Survey Check",
    price: 60.0,
    display: "60.00",
    uid: "9",
  },
  {
    name: "Replace 1st Light Fitting",
    price: 40.0,
    display: "40.00",
    uid: "10",
  },
  {
    name: "Additional Light Fitting/s",
    price: 30.0,
    display: "30.00",
    uid: "11",
  },
];

export const setPricesVatInc = [
  {
    name: "Set Price",
    price: 0.0,
    display: "0.00",
    uid: "0",
  },
  {
    name: "EICR: Flat Rate",
    price: 150.0,
    display: "180.00",
    uid: "1",
  },
  {
    name: "EICR: Additional Circuit",
    price: 16.6666666667,
    display: "20.00",
    uid: "2",
  },
  {
    name: "PAT: Test (x6 items)",
    price: 50.0,
    display: "60.00",
    uid: "3",
  },
  {
    name: "PAT: Additional Item",
    price: 1.6666666667,
    display: "2.00",
    uid: "4",
  },
  {
    name: "Smoke Detector Survey Check",
    price: 50.0,
    display: "60.00",
    uid: "5",
  },
  {
    name: "Call Out Fee",
    price: 50.0,
    display: "60.00",
    uid: "6",
  },
  {
    name: "Landlord's Electrical Survey Check",
    price: 50.0,
    display: "60.00",
    uid: "9",
  },
  {
    name: "Replace 1st Light Fitting",
    price: 33.3333333333,
    display: "40.00",
    uid: "10",
  },
  {
    name: "Additional Light Fitting/s",
    price: 25.0,
    display: "30.00",
    uid: "11",
  },
];

const operatives = [
  {
    initials: "GH",
    name: "Gary Henderson",
    rate: "0.5",
    title: "Apprentice",
    uid: "19012807-3e2d-4f12-89b2-971f630a1597",
  },
  {
    initials: "PH",
    name: "Peter Henderson",
    rate: "1",
    title: "Electrician",
    uid: "c545c341-b0f7-450f-a75c-accaac110618",
  },
];

const rates = [
  {
    accessId: 1,
    description: "Flat Rate",
    name: "Flat Rate",
    ratePerHour: "30.00",
    secondaryRate: "30.00",
    uid: "450d44d2-c5f3-4391-89bf-8e52b2c384c7",
  },
  {
    accessId: 2,
    description: "Scheduled rate for first hour",
    name: "Scheduled rate for first hour",
    ratePerHour: "35.00",
    secondaryRate: "35.00",
    uid: "47988255-5a13-4c15-abbd-9d8dd75a8718",
  },
  {
    accessId: 3,
    description: "Escalated rate",
    name: "Escalated rate",
    ratePerHour: "45.00",
    secondaryRate: "45.00",
    uid: "929240d8-380d-41ac-8d78-2a4c8ad3f8bf",
  },
  {
    accessId: 4,
    description: "Emergency",
    name: "Emergency",
    ratePerHour: "65.00",
    secondaryRate: "65.00",
    uid: "4263ccea-bca2-46d1-88c2-cc65190422c8",
  },
  {
    accessId: 5,
    description: "Survey inspection fee.",
    name: "Visual Inspection Fee",
    ratePerHour: "40.00",
    secondaryRate: "40.00",
    uid: "12493186-2584-4701-a316-e30a4e84f27b",
  },
  {
    accessId: 6,
    description: "Elect + appr.",
    name: "Rate for electrician and apprentice.",
    ratePerHour: "25",
    secondaryRate: "25",
    uid: "14f8fd07-ee3b-411b-b748-af09e175f9ea",
  },
  {
    accessId: 7,
    description: "EICR - Upkeep rate ≤6 circuits",
    name: "EICR - Upkeep ",
    ratePerHour: "98",
    secondaryRate: "98",
    uid: "26f9c22c-c333-46ef-8e8e-1259dcbbbc21",
  },
  {
    accessId: 8,
    description: "EICR - Upkeep - Additional circuits",
    name: "EICR - Upkeep - Additional circuits",
    ratePerHour: "14",
    secondaryRate: "14",
    uid: "8a014f05-c783-4183-974b-f1e7cc89a02b",
  },
  {
    accessId: 9,
    description: "Upkeep base rate",
    name: "Upkeep base rate",
    ratePerHour: "28",
    secondaryRate: "28",
    uid: "5d4668a8-00ea-45c3-949f-f6faf84ed7d2",
  },
  {
    accessId: 10,
    description: "EICR - Domestic flat rate for ≤ 6 circuits",
    name: "EICR - Domestic flat rate for ≤ 6 circuits",
    ratePerHour: "120.00",
    secondaryRate: "120.00",
    uid: "3e41d684-fdea-4dd8-a72a-f44a36ceb01a",
  },
  {
    accessId: 11,
    description: "EICR - Domestic - Additional circuits x1",
    name: "EICR - Domestic - Additional circuits x1",
    ratePerHour: "135",
    secondaryRate: "135",
    uid: "768e83dd-dc5a-4b43-8e7b-03ed8df503ea",
  },
  {
    accessId: 12,
    description: "EICR - Domestic - Additional circuits x2",
    name: "EICR - Domestic - Additional circuits x2",
    ratePerHour: "150.00",
    secondaryRate: "150.00",
    uid: "04a3a7b2-482d-4896-8b6d-7c67d068ca74",
  },
  {
    accessId: 13,
    description: "EICR - Domestic - Additional circuits x3",
    name: "EICR - Domestic - Additional circuits x3",
    ratePerHour: "165.00",
    secondaryRate: "165.00",
    uid: "7d89fa00-acb3-4ed5-81ac-7fff7a50717a",
  },
  {
    accessId: 14,
    description: "EICR - Domestic - Additional circuits x4",
    name: "EICR - Domestic - Additional circuits x4",
    ratePerHour: "180.00",
    secondaryRate: "180.00",
    uid: "40bd3669-c939-48a2-8150-ed41b5cda75c",
  },
  {
    accessId: 15,
    description: "EICR - Domestic - Additional circuits x5",
    name: "EICR - Domestic - Additional circuits x5",
    ratePerHour: "195.00",
    secondaryRate: "195.00",
    uid: "e6361599-0c30-4aef-82b6-f105035017d6",
  },
  {
    accessId: 16,
    description: "EICR - Domestic - Additional circuits x6",
    name: "EICR - Domestic - Additional circuits x6",
    ratePerHour: "210.00",
    secondaryRate: "210.00",
    uid: "4ba05c78-b9a1-461e-b085-835a3232b892",
  },
  {
    accessId: 17,
    description: "---------",
    name: "--------",
    ratePerHour: "50.00",
    secondaryRate: "50.00",
    uid: "cad8d54e-2a84-428f-8d0a-323225c5e43a",
  },
  {
    accessId: 18,
    description: "--------",
    name: "--------",
    ratePerHour: "1",
    secondaryRate: "1",
    uid: "b30d06ea-9b83-4374-88d6-924a57d42ed5",
  },
  {
    accessId: 19,
    description: "--------",
    name: "--------",
    ratePerHour: "1",
    secondaryRate: "1",
    uid: "95c9112c-acf4-4314-a0f4-f27a250c830e",
  },
  {
    accessId: 20,
    description: "EICR - Commercial @ £20 per circuit x6",
    name: "EICR - Commercial @ £20 per circuit x6",
    ratePerHour: "120.00",
    secondaryRate: "120.00",
    uid: "28598c7d-bccd-4723-bf38-89b0a16648f2",
  },
  {
    accessId: 21,
    description: "EICR - Commercial @ £20 per circuit x7",
    name: "EICR - Commercial @ £20 per circuit x7",
    ratePerHour: "140.00",
    secondaryRate: "140.00",
    uid: "2a65d6cc-d4c7-49da-acd9-b8dc90229416",
  },
  {
    accessId: 22,
    description: "EICR - Commercial @ £20 per circuit x8",
    name: "EICR - Commercial @ £20 per circuit x8",
    ratePerHour: "160.00",
    secondaryRate: "160.00",
    uid: "2cc846c1-def4-434f-90ef-169d5aac7ed5",
  },
  {
    accessId: 23,
    description: "EICR - Commercial @ £20 per circuit x9",
    name: "EICR - Commercial @ £20 per circuit x9",
    ratePerHour: "180.00",
    secondaryRate: "180.00",
    uid: "c0d9ff32-6e53-4946-9476-49954b473233",
  },
  {
    accessId: 24,
    description: "EICR - Commercial @ £20 per circuit x10",
    name: "EICR - Commercial @ £20 per circuit x10",
    ratePerHour: "200.00",
    secondaryRate: "200.00",
    uid: "8fc0733a-53da-4623-b21a-a7d59161ec61",
  },
  {
    accessId: 25,
    description: "EICR - Commercial @ £20 per circuit x11",
    name: "EICR - Commercial @ £20 per circuit x11",
    ratePerHour: "220.00",
    secondaryRate: "220.00",
    uid: "6b4367d4-87d7-48b4-9cc4-f7ae4375af72",
  },
  {
    accessId: 26,
    description: "EICR - Commercial @ £20 per circuit x12",
    name: "EICR - Commercial @ £20 per circuit x12",
    ratePerHour: "240.00",
    secondaryRate: "240.00",
    uid: "c9564c5d-2790-4883-958f-448ba1d2b581",
  },
  {
    accessId: 27,
    description: "EICR - Commercial @ £20 per circuit x13",
    name: "EICR - Commercial @ £20 per circuit x13",
    ratePerHour: "260.00",
    secondaryRate: "260.00",
    uid: "f6677973-58f5-48d0-955d-d75bf3fd7054",
  },
  {
    accessId: 28,
    description: "EICR - Commercial @ £20 per circuit x14",
    name: "EICR - Commercial @ £20 per circuit x14",
    ratePerHour: "280.00",
    secondaryRate: "280.00",
    uid: "1ef2e217-af02-40bd-b8e2-3e71864ac6b8",
  },
  {
    accessId: 29,
    description: "EICR - Commercial @ £20 per circuit x15",
    name: "EICR - Commercial @ £20 per circuit x15",
    ratePerHour: "300.00",
    secondaryRate: "300.00",
    uid: "5ccba559-d0e8-4d4a-a7e0-3d9dc791a5f6",
  },
];

const customers = [
  {
    accessId: "Private",
    address: "",
    address2: "",
    authorisedBy: "",
    city: "Glasgow",
    email: "",
    flat: "",
    name: "Private",
    number: "",
    postcode: "",
    uid: "a5b48101-430a-4205-86d6-69da7083a7a0",
    unit: "",
  },
  {
    accessId: "Hayfield",
    address: "260 Moffat Street",
    address2: "Gorbals",
    authorisedBy: "",
    city: "Glasgow",
    email: "",
    flat: "",
    name: "Hayfield",
    number: "0141 429 0335",
    postcode: "G5 0ND",
    uid: "90909cda-3fc5-4943-b078-7cd2e7c9f4f6",
    unit: "",
  },
  {
    accessId: "Rose/Work",
    address: "141 Charles Street",
    address2: "Royston",
    authorisedBy: "",
    city: "Glasgow",
    email: "",
    flat: "",
    name: "Rose/Work",
    number: "0141 552 1199",
    postcode: "G21 2QA",
    uid: "4f5522c7-9b34-46b9-83f6-7c1a9966021b",
    unit: "W6",
  },
  {
    accessId: "Rose/Dev",
    address: "221 Millburn Street",
    address2: "Millburn Centre",
    authorisedBy: "",
    city: "Glasgow",
    email: "",
    flat: "",
    name: "Rose/Dev",
    number: "0141 552 9046",
    postcode: "G21 2HL",
    uid: "ed644a33-e09e-4138-af0d-e2d7b76fd5e2",
    unit: "",
  },
  {
    accessId: "Fruitful Offic",
    address: "145 Charles Street",
    address2: "Rosemount Workspace",
    authorisedBy: "",
    city: "Glasgow",
    email: "",
    flat: "",
    name: "Fruitful Offic",
    number: "07786 077715",
    postcode: "G21 2QA",
    uid: "4d41759a-768c-4a91-91dd-eae6a65a4804",
    unit: "E10",
  },
  {
    accessId: "Focus",
    address: "143 Charles Street",
    address2: "Rosemount Workspace",
    authorisedBy: "",
    city: "Glasgow",
    email: "",
    flat: "",
    name: "Focus",
    number: "0141 564 2952",
    postcode: "G21 2QA",
    uid: "dbb0e64b-257e-4b8a-ba12-a7fb0b88bc55",
    unit: "M3",
  },
  {
    accessId: "ManoJ",
    address: "24 Kilpatrick Drive",
    address2: "Bearsden",
    authorisedBy: "",
    city: "Glasgow",
    email: "",
    flat: "",
    name: "ManoJ",
    number: "0141 942 0871",
    postcode: "G61 4RH",
    uid: "6173d4c5-bd28-4850-be48-3416e1f3c64b",
    unit: "",
  },
  {
    accessId: "Alltrades",
    address: "Unit 4 Elder Court",
    address2: "Lions Drive",
    authorisedBy: "",
    city: "Blackburn",
    email: "",
    flat: "",
    name: "Alltrades",
    number: "01254 269 660",
    postcode: "BB1 2EQ",
    uid: "68c5fd7d-3e3d-4041-b08f-588b5672da34",
    unit: "",
  },
  {
    accessId: "Blooms",
    address: "143 Charles Street",
    address2: "Royston",
    authorisedBy: "",
    city: "Glasgow",
    email: "",
    flat: "",
    name: "Blooms",
    number: "",
    postcode: "G21 2QA",
    uid: "76d9c5e2-e7a9-4550-ac9a-987e4a3d6734",
    unit: "M6",
  },
  {
    accessId: "Clyde Doc",
    address: "Clydesmill Grove",
    address2: "Clydesmill Industrial Estate",
    authorisedBy: "",
    city: "Glasgow",
    email: "",
    flat: "Block 9",
    name: "Clyde Doc",
    number: "0141 641 9480",
    postcode: "G32 8NL",
    uid: "37686a64-1dd3-489f-b024-5db9f89cc1ca",
    unit: "3/4",
  },
  {
    accessId: "Copperworks",
    address: "43 Tharsis Street",
    address2: "Royston",
    authorisedBy: "",
    city: "Glasgow",
    email: "",
    flat: "",
    name: "Copperworks",
    number: "0141 552 7477",
    postcode: "G21 2JF",
    uid: "511ef073-4c3b-4f78-b0c2-21fa1d7bff08",
    unit: "",
  },
  {
    accessId: "Dentist1",
    address: "Rosemount Workspace",
    address2: "141 Charles Street",
    authorisedBy: "",
    city: "Glasgow",
    email: "",
    flat: "",
    name: "Dentist1",
    number: "0141 552 8898",
    postcode: "G21 2QA",
    uid: "ba90eb3a-4c75-405b-bced-41f36df0bf8b",
    unit: "W1",
  },
  {
    accessId: "DOS",
    address: "Brearly Court, Baird Road,",
    address2: "Waterwells Bus. Park, Quedgeley, Gloucester",
    authorisedBy: "",
    city: "Gloucester",
    email: "",
    flat: "",
    name: "DOS",
    number: "01452 881 374",
    postcode: "GL2 2AF",
    uid: "4663eb83-2f35-4dbb-9022-9b1ce2455c8c",
    unit: "6-8",
  },
  {
    accessId: "Freedom Bakery",
    address: "Rosemount Workspace",
    address2: "145 Charles Street",
    authorisedBy: "",
    city: "Glasgow",
    email: "matt@freedombakery.org",
    flat: "",
    name: "Freedom Bakery",
    number: "07875489928",
    postcode: "G21 2QA",
    uid: "a13dd94a-1277-4248-9d75-d064b26653b1",
    unit: "E5",
  },
  {
    accessId: "GHA1",
    address: "Rosemount Workspace",
    address2: "141 Charles Street",
    authorisedBy: "",
    city: "Glasgow",
    email: "",
    flat: "",
    name: "GHA1",
    number: "",
    postcode: "G21 2QA",
    uid: "97493241-e8c6-4eba-8432-3512a7f91451",
    unit: "W15",
  },
  {
    accessId: "HES Purchase",
    address: "68 MacArthur Wynd",
    address2: "Cambuslang",
    authorisedBy: "",
    city: "Glasgow",
    email: "",
    flat: "",
    name: "HES Purchase",
    number: "0141 642 0611",
    postcode: "G727GA",
    uid: "231e533e-b945-4c24-b85a-16261720de56",
    unit: "",
  },
  {
    accessId: "ICHOR",
    address: "Newton Building, Rankine Avenue",
    address2: "Scottish Enterprise Technology Park",
    authorisedBy: "",
    city: "East Kilbride",
    email: "",
    flat: "",
    name: "ICHOR",
    number: "01355 222166",
    postcode: "G75 0QF",
    uid: "cce4bd8e-065b-40b0-abc6-12f4c87c1cf2",
    unit: "",
  },
  {
    accessId: "Lifelink",
    address: "145 Charles Street",
    address2: "Royston",
    authorisedBy: "",
    city: "Glasgow",
    email: "",
    flat: "",
    name: "Lifelink",
    number: "0141 552 4434",
    postcode: "G21 2QA",
    uid: "f99e4d5a-f04d-4086-b48b-9d79f15681c0",
    unit: "E3",
  },
  {
    accessId: "Link",
    address: "Watling House",
    address2: "Callander Business Park",
    authorisedBy: "",
    city: "Falkirk",
    email: "",
    flat: "",
    name: "Link",
    number: "01324 417146",
    postcode: "FK1 1XR",
    uid: "c6dfa47f-0578-4ef0-97f0-0e826c918c07",
    unit: "",
  },
  {
    accessId: "McGinty",
    address: "35 Mossgiel Avenue",
    address2: "Spittal",
    authorisedBy: "",
    city: "Glasgow",
    email: "",
    flat: "",
    name: "McGinty",
    number: "0141 569 4351",
    postcode: "",
    uid: "d98d6649-9a83-4807-9fc6-03985bb8870e",
    unit: "",
  },
  {
    accessId: "Milnbank",
    address: "53 Ballindalloch Drive",
    address2: "Dennistoun",
    authorisedBy: "",
    city: "Glasgow",
    email: "",
    flat: "",
    name: "Milnbank",
    number: "0141 551 8131",
    postcode: "G31 3DQ",
    uid: "4936cb3c-3d4c-481b-bef6-f0fc9143fb04",
    unit: "",
  },
  {
    accessId: "MPJK Star Ltd",
    address: "Rosemount Workspace",
    address2: "141 Charles Street",
    authorisedBy: "",
    city: "Glasgow",
    email: "",
    flat: "",
    name: "MPJK Star Ltd",
    number: "07445212059",
    postcode: "G21 2QA",
    uid: "6c3c9183-4a82-4c3b-9577-eaca024ce502",
    unit: "W12",
  },
  {
    accessId: "NCOS",
    address: "Rosemount Workspace",
    address2: "141 Charles Street",
    authorisedBy: "",
    city: "Glasgow",
    email: "",
    flat: "",
    name: "NCOS",
    number: "0141 552 0567",
    postcode: "G21 2QA",
    uid: "90270a82-d152-4664-b296-d743894e88fe",
    unit: "W10",
  },
  {
    accessId: "Number Sixteen",
    address: "16 Byres Road",
    address2: "Partick",
    authorisedBy: "",
    city: "Glasgow",
    email: "",
    flat: "",
    name: "Number Sixteen",
    number: "0141 339 2544",
    postcode: "G11 5JY",
    uid: "ec8295c1-5871-4346-a507-cbc563a537fe",
    unit: "",
  },
  {
    accessId: "Parkhead",
    address: "40 Helenvale Street",
    address2: "Parkhead",
    authorisedBy: "",
    city: "Glasgow",
    email: "",
    flat: "",
    name: "Parkhead",
    number: "0141 554 6226",
    postcode: "G31 4LS",
    uid: "031bf712-4f8c-45ea-9409-afeacc9c0933",
    unit: "",
  },
  {
    accessId: "RLL",
    address: "Millburn Centre",
    address2: "221 Millburn Street",
    authorisedBy: "",
    city: "Glasgow",
    email: "",
    flat: "",
    name: "RLL",
    number: "",
    postcode: "G21 2HL",
    uid: "792a6c03-30ae-47e2-804a-adb597da196b",
    unit: "",
  },
  {
    accessId: "RLL Flexi",
    address: "102 Royston Road",
    address2: "",
    authorisedBy: "",
    city: "Glasgow",
    email: "",
    flat: "",
    name: "RLL Flexi",
    number: "0141 553 0808",
    postcode: "G21 2NU",
    uid: "a24ccc60-4a3a-4b4b-8af4-81ec1e88e12f",
    unit: "",
  },
  {
    accessId: "Royston Stress",
    address: "145 Charles Street",
    address2: "Royston",
    authorisedBy: "",
    city: "Glasgow",
    email: "",
    flat: "",
    name: "Royston Stress",
    number: "0141 552 4432",
    postcode: "G21 2QA",
    uid: "09e88bb8-9636-494e-b576-2cc078111d82",
    unit: "E10",
  },
  {
    accessId: "Semi",
    address: "Newton Building, Rankine Avenue",
    address2: "Scottish Enterpise Technology Park",
    authorisedBy: "",
    city: "East Kilbride",
    email: "",
    flat: "",
    name: "Semi",
    number: "01355 222166",
    postcode: "G75 0QF",
    uid: "000dd126-e878-436c-91d4-5499150bbcc7",
    unit: "",
  },
  {
    accessId: "Spireview",
    address: "98 James Nisbet Street",
    address2: "Royston",
    authorisedBy: "",
    city: "Glasgow",
    email: "",
    flat: "",
    name: "Spireview",
    number: "0141 552 7928",
    postcode: "G21 2JF",
    uid: "3fcc7804-153b-43be-a615-72564caa730b",
    unit: "",
  },
  {
    accessId: "St Roch Daycar",
    address: "221 Millburn Street",
    address2: "",
    authorisedBy: "",
    city: "Glasgow",
    email: "",
    flat: "",
    name: "St Roch Daycar",
    number: "0141 552 3090",
    postcode: "G21 2HL",
    uid: "ef220a11-acff-4105-8010-f0a3b32cda17",
    unit: "",
  },
  {
    accessId: "St. Rochs",
    address: "Rosemount Workspace",
    address2: "141 Charles Street",
    authorisedBy: "",
    city: "Glasgow",
    email: "",
    flat: "",
    name: "St. Rochs",
    number: "0141 564 3020",
    postcode: "G21 2QA",
    uid: "03cbd5ee-1153-48e7-803a-5309c5f934de",
    unit: "W14",
  },
  {
    accessId: "TCV",
    address: "Balallan House",
    address2: "24 Allan Park",
    authorisedBy: "",
    city: "Stirling",
    email: "",
    flat: "",
    name: "TCV",
    number: "01786 479697",
    postcode: "FK8 2QG",
    uid: "cf9084e0-3534-450a-9d61-e76dabed48c9",
    unit: "",
  },
  {
    accessId: "TCV Doncaster",
    address: "TCV, Sedum House, Mallard Way,",
    address2: "Potteric Carr",
    authorisedBy: "",
    city: " Doncaster",
    email: "",
    flat: "",
    name: "TCV Doncaster",
    number: "",
    postcode: "DN4 8DB",
    uid: "2db70857-7dc0-44d9-8fe6-511e824c879c",
    unit: "",
  },
  {
    accessId: "Tommy Boyle",
    address: "Cambuslang",
    address2: "Cambuslang",
    authorisedBy: "",
    city: "Glasgow",
    email: "",
    flat: "",
    name: "Tommy Boyle",
    number: "",
    postcode: "",
    uid: "8fbee5af-8f49-423f-a64e-3f8ccdc7610e",
    unit: "",
  },
  {
    accessId: "Willie/Mac",
    address: "127 Muirdrum Avenue",
    address2: "Cardonald",
    authorisedBy: "",
    city: "Glasgow",
    email: "",
    flat: "",
    name: "Willie/Mac",
    number: "0141 445 6657",
    postcode: "G52 3AW",
    uid: "824c0fcc-90cc-4c78-906c-b6101fe4e0cd",
    unit: "",
  },
  {
    accessId: "Youth Stress",
    address: "145 Charles Street",
    address2: "",
    authorisedBy: "",
    city: "Glasgow",
    email: "",
    flat: "",
    name: "Youth Stress",
    number: "0141 552 3693",
    postcode: "G21 2QA",
    uid: "8657266d-7d1b-4a93-980c-c081cda20a53",
    unit: "E3",
  },
  {
    accessId: "UPKEEP",
    address: "-",
    address2: "- ",
    authorisedBy: "UPKEEP - David McManus",
    city: "Glasgow",
    email: "upkeepadmin@upkeepglasgow.org.uk",
    flat: "",
    name: "UPKEEP",
    number: "0141 764 3793",
    postcode: "",
    uid: "134c2376-a57b-4e9e-89ed-97e03670f7a0",
    unit: "",
  },
  {
    accessId: "Gallus Property",
    address: "Glasgow Collective",
    address2: "13 - 27 East Campbell Street",
    authorisedBy: "Matthew Gunn",
    city: "Glasgow",
    email: "info@gallusproperty.com",
    flat: "",
    name: "Gallus Property",
    number: "0141 212 0825",
    postcode: "G1 5DT",
    uid: "551a2926-fc5b-4ccd-a093-277e0e7f49d1",
    unit: "",
  },
];

export const defaultCustomer = customers[0];

// Templates for filling in timesheets

export const eicr_setprices = [
  {
    name: "EICR: Flat Rate",
    price: 150.0,
    quantity: 1,
    uid: "1",
  },
  {
    name: "EICR: Additional Circuit",
    price: 15.0,
    quantity: 1,
    uid: "2",
  },
];

export const eicr_remedials_setprices = [];

export const status_of_jobsheets = [
  {
    value: "",
    name: "No Status",
    key: "no-status",
    background: "#303030", // var(--black)
    color: "white",
  },
  {
    value: "more-info",
    name: "More Info",
    key: "more-info",
    background: "#02026e", // blue
    color: "white",
  },
  {
    value: "awaiting-quote",
    name: "Awaiting Quote",
    key: "awaiting-quote",
    background: "#c70202", // red
    color: "white",
  },
  {
    value: "quote-sent",
    name: "Quote Sent",
    key: "quote-sent",
    background: "#ea9903", // orange
    color: "white",
  },
  {
    value: "arrange-date",
    name: "Arrange Date",
    key: "arrange-date",
    background: "purple",
    color: "white",
  },
  {
    value: "booked-in",
    name: "Booked In",
    key: "booked-in",
    background: "#d4d42c", // yellowish
    // background: "#ff000000",
    color: "white",
  },
  {
    value: "provisional",
    name: "Provisional",
    key: "provisional",
    background: "#376a3d", // grey
    color: "white",
  },
  {
    value: "in-progress",
    name: "In Progress",
    key: "in-progress",
    background: "#1fa79f",
    color: "white",
  },
  {
    value: "completed",
    name: "Completed",
    key: "completed",
    // background: "#016c01",
    background: "#02b402",
    color: "white",
  },
  {
    value: "scrubbed",
    name: "Scrubbed",
    key: "scrubbed",
    background: "#606060", // grey
    color: "white",
  },
  {
    value: "unresolved",
    name: "Unresolved",
    key: "unresolved",
    background: "#ff4eb0", // grey
    color: "white",
  },
];

export const HOME_LNG = -4.1485902;
export const HOME_LAT = 55.816631;

export const homeLocation = {
  uid: "home",
  authorisedBy: "Home",
  status: "home-status",
  postcode: "G72 7GA",
  address: "68 Macarthur Wynd",
  address2: "Cambuslang",
  position: {
    lat: HOME_LAT,
    lng: HOME_LNG,
  },
};

export const defaultStatuses = {
  selected: {
    value: "selected",
    name: "Selected",
    key: "selected",
    color: "black",
    background: "#57ffe6",
  },
};

export const statusMap = status_of_jobsheets.reduce((scheme, item) => {
  scheme[item.key] = {
    value: item.value,
    name: item.name,
    key: item.key,
    color: item.color,
    background: item.background,
  };

  return scheme;
}, defaultStatuses);

export const callLogTemplates = {
  phone: {
    templates: [
      {
        name: "No answer",
        text: "Tried calling. No answer. ",
      },
      {
        name: "Left message",
        text: "Left message saying: ",
      },
      {
        name: "Info",
        text: "Customer provided the following info: ",
      },
    ],
  },
  mail: {
    templates: [
      {
        name: "More Info",
        text: "Customer provided the following info: ",
      },
      {
        name: "Question",
        text: "Customer asked for Peter to answer a question: ",
      },
    ],
  },
  booked: {
    templates: [
      {
        name: "Cancelled",
        text: "Customer cancelled the booking",
      },
      {
        name: "Rescheduled",
        text: "Customer asked to reschedule to: ",
      },
      {
        name: "Arrival Time",
        text: "Told customer you would arrive between: ",
      },
    ],
  },
};

export const commentsMaterialTemplates = [
  {
    name: "Smoke (m/w/10)",
    text: "1x Smoke (mains/wire/10)",
  },
  {
    name: "Smoke (m/10)",
    text: "1x Smoke (mains/10)",
  },
  {
    name: "Smoke (w/10)",
    text: "1x Smoke (wire/10)",
  },
  {
    name: "Heat (w/10)",
    text: "1x Heat (wire/10)",
  },
  {
    name: "CO",
    text: "1x CO",
  },
  {
    name: "Control Panel",
    text: "1x Control Panel",
  },
];

export const colourScheme = status_of_jobsheets.reduce((scheme, item) => {
  scheme[item.key] = {
    color: item.color,
    background: item.background,
  };

  return scheme;
}, {});

export const fa_materials = [
  {
    addOnPercentage: 0,
    category: "Detectors",
    itemRefPrice: 20,
    // materialCode: "ae8daa34-d7f0-4d94-8cef-3f5c96097bcc",
    materialDescription: "Smoke det (wireless/10)",
    priceDifference: "0.00",
    priceWithAddOns: "20.00",
    quantity: 1,
  },
  {
    addOnPercentage: 0,
    category: "Detectors",
    itemRefPrice: 20,
    // materialCode: "5cb8eba9-9a51-4d2f-9d55-2867ec2ddcae",
    materialDescription: "Heat det (wireless/10)",
    priceDifference: "0.00",
    priceWithAddOns: "20.00",
    quantity: 1,
  },
  {
    addOnPercentage: 0,
    category: "Detectors",
    itemRefPrice: 22.74,
    // materialCode: "0ee57bf4-4f08-41b0-8e07-96eadab6fed7",
    materialDescription: "CO det (wireless/10)",
    priceDifference: 0,
    priceWithAddOns: 22.74,
    quantity: 1,
  },
  {
    addOnPercentage: 0,
    category: "Detectors",
    itemRefPrice: 36,
    // materialCode: "c293b851-438e-4169-a3b0-f105f27ad596",
    materialDescription: "Control Panel (wireless/10)",
    priceDifference: 0,
    priceWithAddOns: 36,
    quantity: 1,
  },
  {
    addOnPercentage: 0,
    category: "999 Misc",
    itemRefPrice: 0.35,
    // materialCode: "c1914a80-662f-4081-ba2e-4a01281c3a1e",
    materialDescription: "Gyproc anchor/s",
    priceDifference: 0,
    priceWithAddOns: 0.35,
    quantity: 1,
  },
  {
    addOnPercentage: 0,
    category: "999 Misc",
    itemRefPrice: 0.3,
    // materialCode: "f307f10c-03ca-4028-af49-cf0ac4e9d5ee",
    materialDescription: "Filler",
    priceDifference: 0,
    priceWithAddOns: 0.3,
    quantity: 1,
  },
];

export const fuseboard_materials = [
  {
    addOnPercentage: 20,
    category: "Detectors",
    itemRefPrice: 97.0,
    // materialCode: "ae8daa34-d7f0-4d94-8cef-3f5c96097bcc",
    materialDescription: "10 way, twin RCD consumer unit (Mtl)",
    priceDifference: "19.40",
    priceWithAddOns: "116.40",
    quantity: 1,
  },
  {
    addOnPercentage: 0,
    category: "Detectors",
    itemRefPrice: 9.55,
    // materialCode: "5cb8eba9-9a51-4d2f-9d55-2867ec2ddcae",
    materialDescription: "Consumer unit gland",
    priceDifference: "0.00",
    priceWithAddOns: "9.55",
    quantity: 1,
  },
  {
    addOnPercentage: 10,
    category: "Detectors",
    itemRefPrice: 22.25,
    // materialCode: "0ee57bf4-4f08-41b0-8e07-96eadab6fed7",
    materialDescription: "100A isolator",
    priceDifference: "2.23",
    priceWithAddOns: "24.48",
    quantity: 1,
  },
  {
    addOnPercentage: 0,
    category: "Detectors",
    itemRefPrice: 6.69,
    // materialCode: "c293b851-438e-4169-a3b0-f105f27ad596",
    materialDescription: "Fire seal",
    priceDifference: "0",
    priceWithAddOns: "6.69",
    quantity: 1,
  },
  {
    addOnPercentage: 0,
    category: "999 Misc",
    itemRefPrice: 7.89,
    // materialCode: "c1914a80-662f-4081-ba2e-4a01281c3a1e",
    materialDescription: "Fire seal grommet kit",
    priceDifference: "0",
    priceWithAddOns: "7.89",
    quantity: 1,
  },
  {
    addOnPercentage: 5,
    category: "999 Misc",
    itemRefPrice: 0.5,
    // materialCode: "f307f10c-03ca-4028-af49-cf0ac4e9d5ee",
    materialDescription: "Earth Sleeve",
    priceDifference: "0.03",
    priceWithAddOns: "0.53",
    quantity: 2,
  },
  {
    addOnPercentage: 20,
    category: "999 Misc",
    itemRefPrice: 9.22,
    // materialCode: "f307f10c-03ca-4028-af49-cf0ac4e9d5ee",
    materialDescription: "Tenby connectors",
    priceDifference: "1.84",
    priceWithAddOns: "11.06",
    quantity: 3,
  },
  {
    addOnPercentage: 0,
    category: "999 Misc",
    itemRefPrice: 20,
    // materialCode: "f307f10c-03ca-4028-af49-cf0ac4e9d5ee",
    materialDescription: "Consumer unit Tails kit",
    priceDifference: "0",
    priceWithAddOns: "20",
    quantity: 1,
  },
  {
    addOnPercentage: 0,
    category: "999 Misc",
    itemRefPrice: 1.47,
    // materialCode: "f307f10c-03ca-4028-af49-cf0ac4e9d5ee",
    materialDescription: "10 mm Earth wire",
    priceDifference: "0",
    priceWithAddOns: "1.47",
    quantity: 21,
  },
];

export const eicr_remedials_materials = [
  {
    addOnPercentage: 0,
    category: "Custom",
    itemRefPrice: 105.0,
    // materialCode: "ae8daa34-d7f0-4d94-8cef-3f5c96097bcc",
    materialDescription: "Twin rcd fuse board",
    priceDifference: "0.00",
    priceWithAddOns: "105.00",
    quantity: 1,
  },
  {
    addOnPercentage: 0,
    category: "Custom",
    itemRefPrice: 9.99,
    // materialCode: "ae8daa34-d7f0-4d94-8cef-3f5c96097bcc",
    materialDescription: "DB Gland kit",
    priceDifference: "0.00",
    priceWithAddOns: "9.99",
    quantity: 1,
  },
  {
    addOnPercentage: 0,
    category: "Custom",
    itemRefPrice: 6.99,
    // materialCode: "ae8daa34-d7f0-4d94-8cef-3f5c96097bcc",
    materialDescription: "DB Grommet kit",
    priceDifference: "0.00",
    priceWithAddOns: "6.99",
    quantity: 1,
  },
  {
    addOnPercentage: 0,
    category: "Custom",
    itemRefPrice: 1.47,
    // materialCode: "ae8daa34-d7f0-4d94-8cef-3f5c96097bcc",
    materialDescription: "10 mm Earth wire",
    priceDifference: "0.00",
    priceWithAddOns: "1.47",
    quantity: 30,
  },
  {
    addOnPercentage: 0,
    category: "Custom",
    itemRefPrice: 2.99,
    // materialCode: "ae8daa34-d7f0-4d94-8cef-3f5c96097bcc",
    materialDescription: "32mm Bush",
    priceDifference: "0.00",
    priceWithAddOns: "2.99",
    quantity: 2,
  },
  {
    addOnPercentage: 0,
    category: "Custom",
    itemRefPrice: 1.99,
    // materialCode: "ae8daa34-d7f0-4d94-8cef-3f5c96097bcc",
    materialDescription: "32mm Coupler",
    priceDifference: "0.00",
    priceWithAddOns: "1.99",
    quantity: 1,
  },
  {
    addOnPercentage: 0,
    category: "Custom",
    itemRefPrice: 1.66,
    // materialCode: "ae8daa34-d7f0-4d94-8cef-3f5c96097bcc",
    materialDescription: "16 mm Earth wire",
    priceDifference: "0.00",
    priceWithAddOns: "1.66",
    quantity: 2,
  },
  {
    addOnPercentage: 0,
    category: "Custom",
    itemRefPrice: 1.5,
    // materialCode: "ae8daa34-d7f0-4d94-8cef-3f5c96097bcc",
    materialDescription: "Earth Clamp",
    priceDifference: "0.00",
    priceWithAddOns: "1.50",
    quantity: 2,
  },
  {
    addOnPercentage: 0,
    category: "Custom",
    itemRefPrice: 8.69,
    // materialCode: "ae8daa34-d7f0-4d94-8cef-3f5c96097bcc",
    materialDescription: "Trunking (40x25) Non-Adhsv.",
    priceDifference: "0.00",
    priceWithAddOns: "8.69",
    quantity: 1,
  },
  {
    addOnPercentage: 0,
    category: "Custom",
    itemRefPrice: 11.99,
    // materialCode: "ae8daa34-d7f0-4d94-8cef-3f5c96097bcc",
    materialDescription: "Trunking (75x75) Non-Adhsv.",
    priceDifference: "0.00",
    priceWithAddOns: "11.99",
    quantity: 1,
  },
  {
    addOnPercentage: 20,
    category: "Custom",
    itemRefPrice: 18.99,
    // materialCode: "ae8daa34-d7f0-4d94-8cef-3f5c96097bcc",
    materialDescription: "100A Isolator",
    priceDifference: "3.80",
    priceWithAddOns: "22.79",
    quantity: 1,
  },
  {
    addOnPercentage: 0,
    category: "Custom",
    itemRefPrice: 7.99,
    // materialCode: "ae8daa34-d7f0-4d94-8cef-3f5c96097bcc",
    materialDescription: "100A connector",
    priceDifference: "0.00",
    priceWithAddOns: "7.99",
    quantity: 3,
  },
  {
    addOnPercentage: 0,
    category: "Custom",
    itemRefPrice: 3.0,
    // materialCode: "ae8daa34-d7f0-4d94-8cef-3f5c96097bcc",
    materialDescription: "Grommex strip",
    priceDifference: "0.00",
    priceWithAddOns: "3.00",
    quantity: 1,
  },
  {
    addOnPercentage: 15,
    category: "Custom",
    itemRefPrice: 5.99,
    // materialCode: "ae8daa34-d7f0-4d94-8cef-3f5c96097bcc",
    materialDescription: "Intrumescent seal",
    priceDifference: "0.90",
    priceWithAddOns: "6.89",
    quantity: 1,
  },
];

export function seedCustomers(userId) {
  customers.forEach((c) => {
    let customerRef = doc(customersRef, c.uid);
    setDoc(customerRef, { ...c, createdBy: userId })
      .then(() => console.log("seeding ", c.name))
      .catch((err) => {
        console.error("Error seeding customers", c.name, err);
      });
  });
}

export function seedRates(userId) {
  rates.forEach((r) => {
    let rateRef = doc(ratesRef, r.uid);
    setDoc(rateRef, { ...r, createdBy: userId })
      .then(() => console.log("seeding ", r.name))
      .catch((err) => {
        console.error("Error seeding rates", r.name, err);
      });
  });
}

export function seedOperatives(userId) {
  operatives.forEach((o) => {
    let operativeRef = doc(operativesRef, o.uid);
    setDoc(operativeRef, { ...o, createdBy: userId })
      .then(() => console.log("seeding ", o.name))
      .catch((err) => {
        console.error("Error seeding operatives", o.name, err);
      });
  });
}

// hours,
// total,
// labour,
// materials,
// baseMaterials,
// markup,
// gross,
// net,

export const accountantFields = {
  fields: [
    {
      label: "Customer",
      value: "customerId",
    },
    {
      label: "Ref",
      value: "refNumber",
    },
    {
      label: "Hours",
      value: "hours",
    },
    {
      label: "Labour",
      value: "labour",
    },
    {
      label: "Materials",
      value: "materials",
    },
    {
      label: "Gross",
      value: "gross",
    },
    {
      label: "Net",
      value: "net",
    },
    {
      label: "Total",
      value: "total",
    },
  ],
};

export const navigationLinks = [
  { path: "/", label: "Timesheets", matcher: "timesheet" },
  { path: "/quotes", label: "Quotes", matcher: "quote" },
  // Need the trailing / for jobsheet, other Jobsheets will match
  { path: "/jobsheets", label: "Jobsheets", matcher: "jobsheet/" },
  { path: "/calendar", label: "Calendar" },
  { path: "/restores", label: "Restore", matcher: "restore" },
  { path: "/settings", label: "Settings", matcher: "settings" },
];

export const knownContactsArr = [
  "402",
  "201",
  "07908430512",
  "07985448589",
  "07956557418",
  "07410450776",
];
export const knownContacts = {
  402: {
    name: "Peter (Office)",
    number: "402",
  },
  201: {
    name: "Angie (Office)",
    number: "201",
  },
  "07908430512": {
    name: "Paul Henderson",
    number: "07908430512",
  },
  "07985448589": {
    name: "Angela Henderson (Mobile)",
    number: "07985448589",
  },
  "07956557418": {
    name: "Peter Henderson (Mobile)",
    number: "07956557418",
  },
  "07410450776": {
    name: "Gary Henderson",
    number: "07410450776",
  },
  "07941222437": {
    name: "Stuart Henderson",
    number: "07941222437",
  },
  "07411903421": {
    name: "Fiona Kemp",
    number: "07411903421",
  },
  "07934775706": {
    name: "April",
    number: "07934775706",
  },
};

export const tooltips = {
  timesheetConvert: "Convert to Timesheets",
  jobsheetConvert: "Convert to Jobsheets",
  quoteConvert: "Convert to Quotes",
  clone: "Copy",
  goBack: "Back",
  mapView: "Map",
  edit: "Edit",
  closeSlider: "Close Slider",
  bin: "Bin",
  binForever: "Delete Permanently",
  editMaterials: "Edit Materials",
  createTimesheet: "Create Timesheet",
  createJobsheet: "Create Jobsheet",
  createQuote: "Create Quote",
  createJobDescription: "Create Job Description",
  restoreToTimesheets: "Restore to Timesheets",
  restoreToQuotes: "Restore to Quotes",
  restoreToJobsheets: "Restore to Jobsheets",
  jobsheetView: "Jobsheet View",
  pdfView: "PDF View",
  worksOrderView: "Works Order View",
  subcontracted: "Subcontracted",
  FA: "Fire Alarm Template",
  EICR: "EICR Template",
  FUSE: "Fuseboard Template",
  EICR_REMEDIALS: "EICR Remedials",
  vatMode: "VAT Mode (On/Off)",
  vatDiscrepancyError: "VAT Discrepancy error",
};

export const vat_number = "521 839 685";

export const todoers = {
  "63537b3b-a0ec-462c-b0e4-cf4f5b453939": {
    name: "General",
    colourStyle: "#909090",
    initials: "G",
    uid: "63537b3b-a0ec-462c-b0e4-cf4f5b453939",
  },
  "a8f43745-b31c-4270-bd4a-f30cd3da4065": {
    name: "Peter Henderson",
    colourStyle: "#56cdff",
    // colourStyle: "#1b1bf7",
    initials: "PH",
    uid: "a8f43745-b31c-4270-bd4a-f30cd3da4065",
  },
  "c8bc690b-cc67-496d-aa81-47f19e6a012c": {
    name: "Angela Henderson",
    colourStyle: "#ec4be9",
    initials: "AH",
    uid: "c8bc690b-cc67-496d-aa81-47f19e6a012c",
  },
  "a086547b-b4f0-4c5d-952e-ca6c500a9d1b": {
    name: "Gary Henderson",
    colourStyle: "#45bd45",
    initials: "GH",
    uid: "a086547b-b4f0-4c5d-952e-ca6c500a9d1b",
  },
};

// Structure of Data

/*
Primary:

accessId:"Private"(string),
address: "1162 Tollcross"
address2: "Tollcross"
address3: "ff"
authorisedBy: "Paul"
callLog: [
  date:"2022-01-24"
  icon: "phone"
  note:"test"
  time: "12:31"
]
cert: true
city: "Glasgow"
comments: "COmments"
created: 1642871338109
createdBy: 
customerUid: "a5b48101-430a-4205-86d6-69da7083a7a0"
email: "paulyk1162@hotmail.co.uk"
flat: "2/2"
homeNumber: "11111"
jobDetails: "Brief job description here."
jobEnd: "2022-01-16"
jobLocation: "1162 Tollcross"
jobLocation2: "Tollcross"
jobLocation3: "ff"
jobLocationCity: "Glasgow"
jobLocationFlat: "2/2"
jobLocationPostcode: "g727ga"
jobReceived: "2022-01-22"
jobStart: "2022-01-13"
jobsheetDateDay: "12"
jobsheetDateMonth: "02"
jobsheetDateTime: "9:30"
jobsheetReceivedDay: "Mon"
name: "Private"
number: "111"
paid: true
postcode: "g727ga"
primaryType: "jobsheet"
refNumber: "5000"
sent: true
dateSent: "2022-01-12"        // If quote sent through app.
status: "awaiting-quote"
uid: 
unit: "11"
worksOrderNumber: 1067
 

Job Description

created: 1643028791535
createdBy: 
details: "palkndlkd"
hours: "1"
jobDate: "2022-01-24"
materials: [
  addOnPercentage: 0
  category:"1 Lighting"
  itemRefPrice: 3.65
  materialCode: "fcc02d98-3e0a-4180-858c-684a41d0d4ac"
  materialDescription: "Pendant"
  priceDifference: 0
  priceWithAddOns: 3.65
  quantity: 1
]
operatives {
  65fc7a7b-237f-4132-a714-9047d51c4021: "0.5"
  c545c341-b0f7-450f-a75c-accaac110618: "1"
}
rateAccessId: 1
rateId: ""
ratePerHour: "20"
rateUid: "689d85ee-4ebb-44b4-8e43-05b82bbfc7c9"
setPriceList: [
  name: "EICR: flat rate"
  price: 120
  quantity: 1
  uid: "1"
]
uid: 
 




*/
